import { MastraClient } from '@mastra/client-js';

import { env } from '@/env';

let client: MastraClient | null = null;

function createMastraClient(accessToken?: string): MastraClient {
  return new MastraClient({
    baseUrl: env.NEXT_PUBLIC_BACKEND_BASE_URL || '',
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    retries: 0,
  });
}

export function getMastraClient(): MastraClient {
  if (client) return client;
  return createMastraClient();
}

export function updateMastraToken(accessToken: string | undefined) {
  client = createMastraClient(accessToken);
}
